import "./ConfirmLogoutDialog.css";

type ConfirmLogoutDialogProps = {
  isOpen: boolean;
  title: string;
  content: string;
  cancelText: string;
  confirmText: string;
  onCancel: () => void;
  onConfirm: () => void;
  variant?: "danger" | "primary"; 
};

function ConfirmLogoutDialog({
  isOpen,
  title,
  content,
  cancelText,
  confirmText,
  onCancel,
  onConfirm,
  variant = "danger", 
}: ConfirmLogoutDialogProps) {
  if (!isOpen) return null;

  return (
    <div
      className="confirm-logout-overlay"
      role="presentation"
      onClick={onCancel}
    >
      <div
        className="confirm-logout-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="confirm-logout-title"
        onClick={(event) => event.stopPropagation()}
      >
        <h2 id="confirm-logout-title" className="confirm-logout-title">
          {title}
        </h2>

        <p className="confirm-logout-content">
          {content}
        </p>

        <div className="confirm-logout-actions">
          <button
            type="button"
            className="confirm-logout-cancel-btn"
            onClick={onCancel}
          >
            {cancelText}
          </button>

          <button
            type="button"
            className={`confirm-logout-confirm-btn confirm-logout-confirm-btn--${variant}`}
            onClick={onConfirm}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmLogoutDialog;